import { useState } from 'react'

import classes from './WorkersCompDepartments.module.css'
import WorkersCompDrawer from './WorkersCompDrawer'

export default function WorkersCompDepartment({itemData, workerCompData}) {
    const [showDetails, setShowDetails] = useState(false)

    function showDetailshandler() {
        setShowDetails(prevState => prevState = !prevState)
    }

    return <>
        <tr className={classes.department_item}>
            <td onClick={showDetailshandler} colSpan={3}>
                <div className={`${classes.drawer_trigger_mark} ${showDetails ? classes.is_opened : ''}`}>
                    <i className='ti ti-chevron-right'></i>
                    {itemData.name}
                </div>
            </td>
        </tr>
        {showDetails && <tr>
            <td colSpan={3}>
                <WorkersCompDrawer departmentId={itemData.id} workerCompData={workerCompData} />
            </td>    
        </tr>}
    </>
}